import React from "react"

import { ChevronIcon } from "components/page-components/Icons/small"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export const GallerImageModal = ({
  selected_image,
  index,
  close_gallery_modal,
  image,
  go_back,
  go_forward,
}) => {
  const image_data = getImage(image)
  return (
    <div className={`modal ${selected_image === index ? "is-active" : ""}`}>
      <div
        className="modal-background"
        aria-label="close image modal"
        onClick={close_gallery_modal}
        onKeyUp={() => {}} // this is necessary to keep the linter quiet :(
        role="button"
        tabIndex="0"
      ></div>
      <div className="modal-content">
        <GatsbyImage
          image={image_data}
          style={{ maxHeight: "90%" }}
          imgStyle={{ objectFit: "contain" }}
          alt={image.fields.caption || "Galerie Bild"}
          title={image.fields.caption || "Galerie Bild"}
        />
      </div>

      {image.fields.caption && (
        <div className="gallery-caption">{image.fields.caption}</div>
      )}

      <button
        onClick={go_back}
        className="gallery-previous"
        aria-label="previous image"
      >
        <ChevronIcon {...{ rotation: "left", color: "#FFFFFF", size: 2 }} />
      </button>
      <button
        onClick={go_forward}
        className="gallery-next"
        aria-label="next image"
      >
        <ChevronIcon {...{ rotation: "right", color: "#FFFFFF", size: 2 }} />
      </button>

      <button
        className="modal-close is-large"
        aria-label="close"
        onClick={close_gallery_modal}
      ></button>
    </div>
  )
}
